import YYSelectMember from './select-member.vue'

export default YYSelectMember